import * as api from '../api/mapping';
import { asyncAction } from './common';

export const updateMappingCode = (code) => asyncAction('UPDATE_MAPPING', api.updateMapping(code));

export const fetchMapping = () => asyncAction('FETCH_MAPPING', api.fetchMapping());

export const startUpdateMappingCode = (code = '') => ({
  type: 'UPDATE_MAPPING_CODE',
  code,
});

export const cancelUpdateMappingCode = () => ({
  type: 'CANCEL_UPDATE_MAPPING_CODE',
});

export const changeMappingCode = (code) => ({
  type: 'CHANGE_MAPPING_CODE',
  code,
});
